import { useTranslation } from 'react-i18next';

import FloatingActionButton from './FloatingActionButton/FloatingActionButton';
import classes from './Footer.module.css';

const Footer = (props) => {
    const { t } = useTranslation();
    return (
        <>
            <FloatingActionButton />
            <footer className={classes.Footer}>
                <small>
                    {t('footer.copyRight')}
                    <a href="https://elafcorp.com" target='_blank' rel="noreferrer">Elafcorp</a>
                </small>
            </footer>
        </>
    );
}

export default Footer;